__turbopack_context__.v({
  "border_right": "StatsContainer-module-scss-module__McMUIW__border_right",
  "statics_container": "StatsContainer-module-scss-module__McMUIW__statics_container",
  "stats": "StatsContainer-module-scss-module__McMUIW__stats",
  "text1": "StatsContainer-module-scss-module__McMUIW__text1",
  "text2": "StatsContainer-module-scss-module__McMUIW__text2",
});
